export default __webpack_public_path__ + "static/winter5-2580baa2afd9aa6d71df6401aefdaa2e.webp";